import { registerLocaleData } from "@angular/common";
import localeSv from "@angular/common/locales/sv";
import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import moment from "moment";
import "moment/locale/sv";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

if (environment.production) {
    enableProdMode();
}

registerLocaleData(localeSv, "sv");
moment.locale("sv");
ModuleRegistry.registerModules([AllCommunityModule]);

bootstrapApplication(AppComponent, appConfig);
